var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-agreement",attrs:{"id":"trs-main"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"box panel-agreement"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }